import './PublicTempSessionStyles.css';

export default function SessionDomainErrorPage() {
  const currentDomain = window.location.hostname;

  return (
    <main className="ts-page">
      <div className="ts-shell">
        <div className="ts-hero">
          <span className="ts-badge">
            🔒 Accès restreint
          </span>
          <h1>Domaine réservé aux sessions</h1>
        </div>

        <div className="ts-status-card">
          <svg className="ts-status-icon" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="1.5" style={{ color: '#fbbf24' }}>
            <path d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126z" />
            <path d="M12 15.75h.007v.008H12v-.008z" />
          </svg>
          <h2>Ce domaine est dédié aux sessions de formation</h2>
          <p style={{ maxWidth: '480px', margin: '0.75rem auto 0' }}>
            Pour accéder à votre session, veuillez utiliser le <strong style={{ color: '#c4b5fd' }}>lien complet</strong> qui vous a été communiqué par votre formateur.
          </p>

          <div style={{
            marginTop: '2rem',
            padding: '1.25rem 1.5rem',
            borderRadius: '0.75rem',
            background: 'rgba(124, 58, 237, 0.08)',
            border: '1px solid rgba(124, 58, 237, 0.2)',
            textAlign: 'left',
            maxWidth: '480px',
            margin: '2rem auto 0',
          }}>
            <p style={{ fontSize: '0.8rem', color: '#a78bfa', fontWeight: 600, marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Format attendu
            </p>
            <p style={{
              fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
              fontSize: '0.88rem',
              color: '#c4b5fd',
              wordBreak: 'break-all',
              lineHeight: 1.6,
            }}>
              https://{currentDomain}/session/<span style={{ color: '#34d399', fontWeight: 600 }}>nom-de-votre-session</span>
            </p>
          </div>

          <div style={{
            marginTop: '1.5rem',
            padding: '1rem 1.25rem',
            borderRadius: '0.75rem',
            background: 'rgba(251, 191, 36, 0.06)',
            border: '1px solid rgba(251, 191, 36, 0.15)',
            maxWidth: '480px',
            margin: '1.5rem auto 0',
          }}>
            <p style={{ fontSize: '0.82rem', color: '#fbbf24', lineHeight: 1.6 }}>
              💡 <strong>Besoin d'aide ?</strong> Contactez votre formateur pour obtenir le lien d'accès à votre session.
            </p>
          </div>
        </div>

        <div className="ts-footer">
          Propulsé par <a href="https://takapes.info">Takapes Learn</a>
        </div>
      </div>
    </main>
  );
}
